import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import SignupField from '@piconetworks/pkg-field-signup';
import styles from './Signup.module.scss.js';
import getFields from './getFields.js';

var SignupPreview = function SignupPreview(_ref) {
  var authenticationMethods = _ref.authenticationMethods,
    brandName = _ref.brandName,
    default_authentication_method = _ref.default_authentication_method,
    draftJsValue = _ref.draftJsValue,
    email_signup_method = _ref.email_signup_method,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields,
    formSubtitle = _ref.formSubtitle,
    formTitle = _ref.formTitle,
    getCustomText = _ref.getCustomText,
    newsletters = _ref.newsletters,
    phone_signup_method = _ref.phone_signup_method;
  // If page has theme, linkColor should be blockContrastColor
  // to render newsletter checkboxes correctly.
  var getCustomLinkColor = function getCustomLinkColor() {
    var previewStyles = document.querySelector('#preview');
    if (previewStyles === null) return;
    var cs = getComputedStyle(previewStyles);
    return cs.getPropertyValue('--blockContrastColor');
  };
  var linkColor = getCustomLinkColor();
  var typeMap = {
    // Custom property types
    dropdown: 'Dropdown',
    short_answer: 'Text',
    number: 'Number',
    url: 'Text',
    paragraph: 'Text',
    radio: 'Radio',
    boolean: 'Boolean',
    checkbox: 'Checkbox',
    // Standard property types
    first_name: 'Text',
    last_name: 'Text',
    address: 'Address',
    phone_number: 'Text',
    gender: 'Text',
    birthday: 'Text',
    date: 'Date'
  };
  var mappedFields = fields.map(function (field) {
    return {
      id: field === null || field === void 0 ? void 0 : field.connected_property,
      title: field === null || field === void 0 ? void 0 : field.label,
      description: field === null || field === void 0 ? void 0 : field.description,
      type: typeMap === null || typeMap === void 0 ? void 0 : typeMap[field === null || field === void 0 ? void 0 : field.connected_property],
      order: field === null || field === void 0 ? void 0 : field.order
    };
  });
  var field = useCallback(getFields(mappedFields, 'customFields'), [JSON.stringify(mappedFields)]);
  var getAuthMethods = useCallback(function () {
    return [].concat(authenticationMethods.filter(function (method) {
      return !['email', 'sms'].includes(method);
    }), email_signup_method ? ['email'] : [], phone_signup_method ? ['sms'] : []);
  }, [authenticationMethods, email_signup_method, phone_signup_method]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'block ' + styles.container
  }, getCustomText(draftJsValue), (!!authenticationMethods.length || email_signup_method || phone_signup_method) && /*#__PURE__*/React.createElement("div", {
    className: styles.email
  }, /*#__PURE__*/React.createElement(SignupField, {
    name: "signup",
    title: formTitle || '',
    subtitle: formSubtitle || '',
    previewMode: true,
    newsletters: newsletters,
    authenticationMethods: getAuthMethods(),
    customFields: field,
    linkColor: linkColor,
    defaultType: {
      type: default_authentication_method
    },
    showTerms: true,
    username: brandName
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.loginText
  }, "Already signed up?", /*#__PURE__*/React.createElement("div", null, "Log in")))));
};
SignupPreview.propTypes = {
  authenticationMethods: PropTypes.array,
  brandName: PropTypes.string,
  default_authentication_method: PropTypes.string,
  draftJsValue: PropTypes.object,
  email_signup_method: PropTypes.bool,
  fields: PropTypes.array,
  formSubtitle: PropTypes.string,
  formTitle: PropTypes.string,
  getCustomText: PropTypes.func,
  newsletters: PropTypes.array,
  phone_signup_method: PropTypes.bool
};
var SignupPreview$1 = /*#__PURE__*/React.memo(SignupPreview);

export { SignupPreview$1 as default };
//# sourceMappingURL=index.js.map
